import {Container, SimpleGrid} from '@chakra-ui/react';
import WealthChart from '../../components/WealthChart';
import AssetsAllocationPieChart from '../../components/AssetsAllocationPieChart';
import AssetsTable from '../../components/AssetsTable';
import { useState } from 'react';
import AddAssetModal from '../../components/NewAssetModal';

const DashboardPage = () => {
  const [refresh, setRefresh] = useState(false);

  const handleAssetAdded = () => {
    setRefresh(!refresh);
  };

  return (
    <Container maxW="container.xl" py={8}>

      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8}>
        <WealthChart />
        <AssetsAllocationPieChart />
      </SimpleGrid>

      <AddAssetModal onAssetAdded={handleAssetAdded}/>
      <AssetsTable refresh={refresh}/>

    </Container>
  );
};

export default DashboardPage;